import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE, LOGO } from "@/content/site";
import { Reveal } from "@/components/Reveal";

export const CTABand = ({ title = "Ready for a pool you never have to worry about?", text = "Request a quote today and find out how simple dependable weekly pool service can be." }) => (
  <section data-testid="cta-band" className="py-16 sm:py-20 bg-shell">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-navy via-deepsea to-pine px-6 py-14 sm:px-12 sm:py-16 lg:px-16 text-center">
          <div className="noise-overlay absolute inset-0 opacity-[0.05] pointer-events-none" />
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-lagoon/20 blur-[100px] pointer-events-none" />
          <div className="relative">
            <img
              src={LOGO.chip}
              alt=""
              data-testid="cta-band-logo"
              className="h-16 w-16 mx-auto mb-6 rounded-full shadow-lg shadow-black/30"
            />
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-white max-w-2xl mx-auto">
              {title}
            </h2>
            <p className="mt-4 text-base text-slate-300 max-w-xl mx-auto">{text}</p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3.5">
              <Link
                to="/contact/"
                data-testid="cta-band-quote-button"
                className="group inline-flex items-center justify-center gap-2.5 bg-aqua text-navy font-bold px-8 py-4 rounded-full transition-all duration-300 hover:bg-sky2 hover:text-navy hover:shadow-xl hover:shadow-cyan-500/30 hover:-translate-y-0.5"
              >
                Request a Quote
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a
                href={SITE.phoneHref}
                data-testid="cta-band-call-button"
                className="inline-flex items-center justify-center gap-2.5 border-2 border-white/25 text-white font-bold px-8 py-4 rounded-full transition-all duration-300 hover:bg-white hover:text-navy"
              >
                <Phone className="w-5 h-5" /> {SITE.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
